// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"167":"c8649fb8","494":"8ac029cf","773":"de8f7f06","945":"8ac17543"}[chunkId] + ".js";
};